import React, { useState, useEffect } from "react";
import AsideLeft from "./AppAdminComponents/AsideLeft";
import NavBarNotificationBar from "./AppAdminComponents/NavBarNotificationBar";
import { getuser } from "../helpers/user.helper";
import formatMoney from "../helpers/money.helper";
import formatDate from "../helpers/date.helper";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useNavigate } from "react-router-dom";
import {
  ListCustomers,
  GetCustomer,
  GetCustomerLikeName,
  ListCustomersPaginate,
} from "../services/customer.service";
import { List, setCustomerUser } from "../services/user.service";
import { isAdministratorUser } from "../helpers/user.helper";
import Loader from "react-loader-spinner";
import Modal from "react-modal";
import AsyncSelect from "react-select/async";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Footer from "../components/Footer";

export default function Customers() {
  let navigate = useNavigate();
  const [customersArray, setCustomers] = useState(undefined);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const [inputValue, setValue] = useState("");
  const [totalPage, setTotalPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [selectedGridRow, setSelectedGridRow] = useState(null);
  const [isLoadingChange, setisLoadingChange] = useState(false);
  const [filters, setFilters] = useState();

  useEffect(() => {
    let user = getuser();
    //Redireciona caso não esteja logado
    if (!user) {
      navigate("/login");
    }

    async function fetchData() {
      await fetchCustomers(10, 1);
    }

    fetchData();
  }, []);

  async function fetchCustomers(sizeRows, page, isPaginate) {
    let customers = await ListCustomersPaginate(sizeRows, page);
    setCustomers(customers?.data.data);
    setTotalPage(customers.data.totalPages);
    setTotalRecords(customers.data.totalItems);
  }

  const customStyles = {
    content: {
      width: "60%",
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };

  function openModal(rowData) {
    setSelectedGridRow(rowData);
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  const showItemClick = (rowData) => {
    navigate(`/cliente/${rowData.codigo}`);
  };

  const showVendasCliente = (rowData) => {
    navigate(`/venda/cliente/${rowData.codigo}`, { customer: rowData });
  };

  let renderLoad = () => {
    return (
      <div className="table-footer text-center">
        <Loader
          type="ThreeDots"
          color="#343A40"
          height={100}
          width={100}
          visible={true}
        />
      </div>
    );
  };

  const optionButtons = (rowData, column) => {
    return (
      <div>
        <button
          onClick={() => showItemClick(rowData)}
          title="Visualizar item"
          type="button"
          className="btn btn-icon btn-info btn-sm"
        >
          <i className="fa fa-edit"></i>
        </button>
        &nbsp;
        {isAdministratorUser() && (
          <button
            onClick={() => openModal(rowData)}
            title="Vincular responsável"
            type="button"
            className="btn btn-icon btn-warning btn-sm"
          >
            <i className="fa fa-user"></i>
          </button>
        )}
        <button
          onClick={() => showVendasCliente(rowData)}
          title="Visualizar Vendas do cliente"
          type="button"
          className="btn btn-icon btn-danger btn-sm"
        >
          <i className="fa fa-shopping-cart"></i>
        </button>
      </div>
    );
  };

  const handleInputChange = (value) => {
    setValue(value);
  };

  const handleChange = (value) => {
    setSelectedValue(value);
  };

  const loadOptions = async (inputValue) => {
    let users = await List();
    return users.data;
  };

  const cancelModal = () => {
    setSelectedGridRow(undefined);
    closeModal();
  };

  const saveDataAndCloseModal = async () => {
    setisLoadingChange(true);
    await setCustomerUser(selectedGridRow.codigo, selectedValue.id);

    let customers = await ListCustomers();
    setCustomers(customers?.data);

    setSelectedGridRow(undefined);
    closeModal();
    setisLoadingChange(false);
  };

  const onPage = async (event) => {
    setFirst(event.first);
    let customers = await ListCustomersPaginate(
      event.rows,
      event.page + 1,
      true
    );
    setCustomers(customers?.data.data);
  };

  const onFilter = async (event) => {
    console.log(event);
    if (Object.keys(event.filters).length === 0) {
      await fetchCustomers(10,1);
    } else {
      const { codigo, nome, responsavel } = event.filters;
      if (codigo && codigo.value.length === 4) {
        const customerResult = await GetCustomer(codigo.value);
        setCustomers(customerResult.data);
        setTotalRecords(customerResult.data.length);
      }

      if (!codigo && nome && nome.value.length > 3) {
        const customerResult = await GetCustomerLikeName(nome.value, 10, 1);
        setCustomers(customerResult.data.data);
        setTotalRecords(customerResult.data.data.length);
      }

    //   if (!codigo && responsavel && responsavel.value.length > 3) {
    //     const customerResult = await GetCustomerLikeName(responsavel.value);
    //     setCustomers(customerResult.data);
    //     setTotalRecords(customerResult.data.length);
    //   }
    }
    setFilters(event.filters);
  };

  return (
    <>
      <div className="wrapper">
        <div>
          <button onClick={openModal}>Open Modal</button>
          <Modal
            isOpen={modalIsOpen}
            style={customStyles}
            contentLabel="Example Modal"
          >
            <div className="row">
              <div className="col-12">
                <h3>{selectedGridRow?.nome}</h3>
                <div className="form-group">
                  <label>Usuário responsável</label>
                  <AsyncSelect
                    cacheOptions
                    defaultOptions
                    value={selectedValue}
                    getOptionLabel={(e) => e.nome}
                    getOptionValue={(e) => e.id}
                    loadOptions={loadOptions}
                    onInputChange={handleInputChange}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="form-group">
                  <button className="btn btn-primary" onClick={cancelModal}>
                    Cancelar
                  </button>
                  <button
                    className="btn btn-success"
                    onClick={saveDataAndCloseModal}
                  >
                    <span
                      className={
                        isLoadingChange
                          ? " spinner-border spinner-border-sm"
                          : ""
                      }
                    ></span>{" "}
                    Salvar
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        </div>

        {/* Navbar */}
        <nav className="main-header navbar navbar-expand navbar-white navbar-light">
          <NavBarNotificationBar />
        </nav>
        <AsideLeft option="clientes" />
        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1 className="m-0 text-dark">Clientes</h1>
                </div>
              </div>
            </div>
          </div>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                {/* Left col */}
                <section className="col-lg-12 connectedSortable">
                  {/* Custom tabs (Charts with tabs)*/}
                  <div className="card">
                    <div className="card-header">
                      {/* <div className="card-tools">
                                                <ul className="nav nav-pills ml-auto">
                                                    <li className="nav-item">
                                                        <a className="nav-link active" href="/venda/nova" data-toggle="tab">Nova</a>
                                                    </li>
                                                </ul>
                                            </div> */}
                    </div>
                    <div className="card-body">
                      {!customersArray ? (
                        renderLoad()
                      ) : (
                        <div className="tab-content p-0">
                          <DataTable
                            value={customersArray}
                            rowHover
                            paginator
                            rows={20}
                            lazy={true}
                            first={first}
                            onPage={(event) => onPage(event)}
                            onFilter={onFilter}
                            filters={filters}
                            totalRecords={totalRecords}
                            rowsPerPageOptions={[20, 40, 50]}
                            style={{ marginBottom: 50 }}
                            responsive
                            className="p-datatable-customers"
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros"
                            emptyMessage="Não existem dados para exibir"
                          >
                            <Column
                              field="codigo"
                              header="Código"
                              filter={true}
                            />
                            <Column field="nome" header="Nome" filter={true} />
                            <Column
                              field="responsavel"
                              header="Responsável"
                            />
                            <Column field="cidade" header="Cidade" />
                            <Column
                              field="qtdItensVendidos"
                              header="Qtd. Peças/Mês(atual)"
                            />
                            <Column
                              field={(row) => formatMoney(row.totalVendas)}
                              header="Total Vendido/Mês(atual)"
                            />
                            <Column
                              field={(row) => formatDate(row.dataImportacao)}
                              header="Atualizado Em"
                            />
                            <Column
                              key="123"
                              body={optionButtons}
                              bodyStyle={{
                                textAlign: "center",
                                overflow: "hidden",
                              }}
                            />
                          </DataTable>
                        </div>
                      )}
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </section>
        </div>

        <Footer />
      </div>
    </>
  );
}
